import React from "react";
import Box from "@mui/material/Box";

const SidebarIcon = ({ iconNode, isActive }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 42,
        height: 42,
        borderRadius: "8px",
        backgroundColor: isActive ? "var(--palette-primary_main, #3c2884)" : "transparent",
        transition: "background-color 0.2s ease",
        color: isActive ? "#fff" : "var(--palette-header_text, #fff)",
        "&:hover": {
          backgroundColor: isActive
            ? "var(--palette-primary_main, #3c2884)"
            : "rgba(255,255,255,0.08)",
        },
      }}
    >
      <Box sx={{ display: "flex", color: "inherit" }}>
        {iconNode}
      </Box>
    </Box>
  );
};

export default SidebarIcon;
